import React, { useEffect } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { IconCircleCheck, IconCircleX } from "@tabler/icons-react";
import styles from "./StatusModal.module.css";

export default function StatusModal({ opened, onClose, status }) {
  // useEffect(() => {
  //   if (opened && status) {
  //     // Auto close after 3 seconds
  //     const timer = setTimeout(() => {
  //       onClose();
  //     }, 3000);

  //     return () => clearTimeout(timer);
  //   }
  // }, [opened, status, onClose]);

  return (
    <AnimatePresence>
      {opened && (
        <>
          {/* Backdrop */}
          <motion.div
            className={styles.backdrop}
            onClick={onClose}
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            transition={{ duration: 0.3 }}
          />

          {/* Modal */}
          <div className={styles.modalWrapper}>
            <motion.div
              className={styles.modal}
              initial={{ opacity: 0, scale: 0.95 }}
              animate={{ opacity: 1, scale: 1 }}
              exit={{ opacity: 0, scale: 0.95 }}
              transition={{ duration: 0.3, ease: "easeOut" }}
            >
              {/* Close Button */}
              <button className={styles.closeButton} onClick={onClose} aria-label="Close modal">
                ✕
              </button>

              {/* Status Content */}
              <div className={styles.statusContent}>
                {status === "success" ? (
                  <>
                    <IconCircleCheck size={80} color="#2BA24C" stroke={1.5} />
                    <h2 className={`${styles.statusTitle} ${styles.success}`}>You have been Successfully Registered</h2>
                    <p className={styles.statusSubtitle}>Visit us at IFEX 2026, Hall 6, Stall D2</p>
                  </>
                ) : (
                  <>
                    <IconCircleX size={80} color="#F44336" stroke={1.5} />
                    <h2 className={`${styles.statusTitle} ${styles.error}`}>Something went wrong</h2>
                    <p className={styles.statusSubtitle}>Please try again later or contact support</p>
                  </>
                )}
              </div>
            </motion.div>
          </div>
        </>
      )}
    </AnimatePresence>
  );
}
